import { css, styled } from "@puzzle/theme";
import { CalendarView } from "./types";

const cellStyles = css({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: "$bold",
  fontSize: "13px",
  lineHeight: "16px",
  height: 36,
  minWidth: 36,
});

export const Cell = styled("div", cellStyles, {
  $$borderRadius: "$radii$2",
  userSelect: "none",

  defaultVariants: {
    dark: false,
    disabled: false,
    outside: false,
    today: false,

    selected: false,
    selectedStart: false,
    selectedMiddle: false,
    selectedEnd: false,
  },

  variants: {
    unit: {
      [CalendarView.Day]: {},
      [CalendarView.Quarter]: {},
      [CalendarView.Month]: {
        width: "auto",
      },
      [CalendarView.Year]: {},
    },

    outside: {
      false: {},
      true: {
        color: "$text-neutral-subdue",
      },
    },

    disabled: {
      false: {
        cursor: "pointer",
        color: "$text-neutral-moreHighlight",
      },
      true: {
        color: "$text-neutral-subdue",
        textDecoration: "line-through",

        "&:not(:empty)": {
          cursor: "not-allowed",
        },
      },
    },

    dark: {
      true: {},
      false: {},
    },

    selected: {
      true: {},
      false: {},
    },

    selectedStart: {
      true: {},
      false: {},
    },

    selectedMiddle: {
      true: {},
      false: {},
    },

    selectedEnd: {
      true: {},
      false: {},
    },

    today: {
      true: {
        color: "$outline-special-base",
      },
      false: {},
    },
  },

  // TOFIX: using outline-special here becasue we don't have surface-special yet
  compoundVariants: [
    {
      disabled: false,
      selected: false,
      css: {
        "&:hover": {
          backgroundColor: "$surface-neutral-base",
        },
      },
    },
    {
      selectedStart: false,
      selectedMiddle: false,
      selectedEnd: false,
      selected: true,
      css: {
        borderRadius: "$$borderRadius",
        backgroundColor: "$outline-special-subdue",
        color: "$outline-special-highlight",
      },
    },
    {
      selectedMiddle: true, // Middle of selection
      selectedStart: false,
      selectedEnd: false,
      selected: true,
      css: {
        backgroundColor: "$outline-special-subdue",

        "&:hover": {
          backgroundColor: "$outline-special-base",
        },
      },
    },
    {
      selectedMiddle: true, // Middle of selection in Dark Mode
      selectedStart: false,
      selectedEnd: false,
      selected: true,
      dark: true,
      css: {
        backgroundColor: "$outline-special-subdue",

        "&:hover": {
          backgroundColor: "$outline-special-base",
        },
      },
    },
    {
      selected: true, // Start of selection
      selectedStart: true,
      css: {
        backgroundColor: "$outline-special-subdue",
        color: "$text-neutral-base",
        borderTopLeftRadius: "$$borderRadius",
        borderBottomLeftRadius: "$$borderRadius",

        "&:hover": {
          backgroundColor: "$outline-special-subdue",
        },
      },
    },
    {
      selected: true, // End of selection
      selectedEnd: true,
      css: {
        backgroundColor: "$outline-special-subdue",
        color: "$text-neutral-base",
        borderTopRightRadius: "$$borderRadius",
        borderBottomRightRadius: "$$borderRadius",

        "&:hover": {
          backgroundColor: "$outline-special-subdue",
        },
      },
    },
  ],
});

export const HeaderCell = styled("div", cellStyles, {
  color: "$text-neutral-moreSubdue",
});
